<app-base-today-statistics
[title]="title"
[getItemsApiMethodName]="getItemsApiMethodName"
[barChartId]="barChartId"
[doughnutChartId]="doughnutChartId"
[isShowUserDropDown]="true"
[isOnlyUserSelect]="true"
[userType]="userType"
>
</app-base-today-statistics>
